import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import {getJSON} from '../components/GlobalFunctions';

import humanizeDuration from "humanize-duration/humanize-duration";

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import pricing_policy from '../img/pricing_policy/pricing-policy-1.svg'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Pricing_policy extends React.Component {

	constructor() {
		super();
		this.state = {
			average: '',
			averageOrders: '',
			orders: []
		}
	}

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	fixedSidebar() {

	    var sidebar = document.getElementById('sidebar'), sidebar_scroll = document.getElementById('sidebar-scroll'), content = document.getElementById('content');
		var scrTop = window.pageYOffset,
			formOuterH = getAbsoluteHeight(sidebar_scroll),
			formH = sidebar_scroll.clientHeight,
			contentH = content.clientHeight,
			contentOfTop = getElementTop(content),
			sidebarH = sidebar.clientHeight,
			sidebarOfTop = getElementTop(sidebar),
			contentB = contentH + contentOfTop;

	    if (window.innerHeight > 767) {
			if (contentH > (sidebarH + formOuterH)) {
				sidebar_scroll.parentNode.setAttribute('style', 'min-height:'+formOuterH+'px');
				if (scrTop >= sidebarOfTop - 70) {
					sidebar_scroll.setAttribute('data-fixed', true);

					if (contentB < (scrTop + formH + 70)) {
						sidebar_scroll.setAttribute('style', 'top:'+(-((scrTop + formH) - contentB))+'px');
					} else {
						sidebar_scroll.setAttribute('style', 'top:70px');
					}

				} else {
					sidebar_scroll.setAttribute('style', 'top:auto');
					sidebar_scroll.removeAttribute('data-fixed');
				}
			}
		}

		function getElementTop(e){for(var t=e.offsetTop,a=e.offsetParent;null!=a;)t+=a.offsetTop,a=a.offsetParent;return t}

		function getAbsoluteHeight(t){t="string"==typeof t?document.querySelector(t):t;var e=window.getComputedStyle(t),o=parseFloat(e.marginTop)+parseFloat(e.marginBottom);return Math.ceil(t.offsetHeight+o)}

	}

	writerDeadline(time) {

		var shortEnglishHumanizer = humanizeDuration.humanizer({
			largest: 2,
			language: 'shortEn',
			languages: {
				shortEn: {
					y: function() { return 'y' },
					mo: function() { return 'mo' },
					w: function() { return 'w' },
					d: function() { return 'd' },
					h: function() { return 'h' },
					m: function() { return 'm' },
					s: function() { return 's' },
					ms: function() { return 'ms' },
				}
			}
		});

		if(time !== '—') {
			var timeParts = time.split(":"), milisec = timeParts[0] * 3600000 + timeParts[1] * 60000 + timeParts[2] * 1000;
			return shortEnglishHumanizer(milisec);
		} else {
			return time;
		}

	} 

	componentDidMount() {
	    var mask = document.getElementById('mask'), self = this;
	    mask.addEventListener('touchstart', this.pageClick, false);

		getJSON('GET', '/api/orders/available/total', null, function(data){
			if (typeof data === 'string') data = JSON.parse(data);
			self.setState({average: data.avg});
			self.setState({averageOrders: data.count});
		}, function(status){});

		getJSON('GET', '/api/orders/available?limit=50', null, function(data){ 
			if (typeof data === 'string') data = JSON.parse(data);
			var orders = Object.keys(data.data).map(function (key) { return data.data[key]; });

			self.setState({orders: orders});

		}, function(status){});

    	this.fixedSidebar;
		
		window.addEventListener('scroll', this.fixedSidebar, false);

		window.addEventListener('resize', this.fixedSidebar, false);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.fixedSidebar);
		window.removeEventListener('resize', this.fixedSidebar);
	}

	render() {
		var self = this;
		return (
			<div>

				<Helmet
					title="View all available orders for remote academic writers - UvoCorp.com"
					meta={[
						{ name: "description", content: "You can view all currently available orders, along with their disciplines, academic levels, and prices that are paid to remote academic writers for completing orders." },

						{ property: 'og:title', content: "View all available orders for remote academic writers - UvoCorp.com" },
						{ property: 'og:description', content: "You can view all currently available orders, along with their disciplines, academic levels, and prices that are paid to remote academic writers for completing orders." },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/view_all_orders.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">

					<div className="inner-header">
						<div className="container">
							<h1>View all orders</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>


					<div className="inner-white">
						<div className="container">
							<div id="content" className="col-md-8">

								<div className="inner-current-projects-text">
									<p>Currently available orders: <strong className="home-teal-color">{this.state.averageOrders}</strong></p>
									<p>Average order price: <strong className="home-teal-color">${this.state.average}</strong></p>
								</div>

								<div className="inner-table">
									<h3 className="inner-table-header">Current projects offered</h3>
									<table className="inner-table-tbody inner-table-tbody-row">
										<colgroup>
											<col width="40"/>
											<col/>
											<col width="130"/>
											<col width="70"/>
											<col width="90"/>
											<col width="90"/>
										</colgroup>
										<tbody>
											<tr className="inner-table-tr inner-table-tr-row">
												<th className="inner-table-row-th">#</th>
												<th className="inner-table-row-th">Discipline</th>
												<th className="inner-table-row-th">Academic level</th>
												<th className="inner-table-row-th">Pages</th>
												<th className="inner-table-row-th">Deadline</th>
												<th className="inner-table-row-th">Cost</th>
											</tr>
											{
												this.state.orders.map(function (order, index) {
													return  (
														<tr className="inner-table-tr inner-table-tr-row" key={index}>
															<td className="inner-table-row-td">{index + 1}</td>
															<td className="inner-table-row-td">{order.category}</td>
															<td className="inner-table-row-td">{order.course}</td>
															<td className="inner-table-row-td">{order.pages}</td>
															
															<td className="inner-table-row-td">{order.writer_deadline ? (
														        <span className="">{self.writerDeadline(order.writer_deadline)}</span>
														      ) : (
														        <span>—</span>
														      )}
														    </td>

															<td className="inner-table-row-td"><span className="">$</span>{order.cost}</td>
														</tr>
													)
												})
											}
										</tbody>
									</table>
								</div>
								<p className="inner-table-supinfo">Not more than 50 orders are shown</p>

							</div>
							<div className="col-md-4">
								<div id="sidebar" className="sidebar">
									<div id="sidebar-scroll" className="sidebar-scroll">
										<div className="sidebar-img">
											<img src={pricing_policy} alt="Pricing Policy"/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>
				
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/view_all_orders.html.js